"use client"

import { SectionHeader, SeeAllButton } from "@/components/marketplace/layout/section-header"
import { ProductCard } from "@/components/marketplace/product/product-card"
import { RailArrows } from "@/components/marketplace/product/rail-arrows"
import type { Product } from "@/components/marketplace/types"
import { WindowedReel } from "@/components/ui"
import { useReelPagination } from "@/lib/hooks/use-reel-pagination"

interface DropRailProps {
  eyebrow?: string
  title: string
  accent?: string
  products: Product[]
  seeAllHref?: string
  ranked?: boolean
  variant?: "default" | "bare"
}

export const DropRail = ({ eyebrow, title, accent, products, seeAllHref, ranked = true, variant = "default" }: DropRailProps) => {
  const { ref, overflowing, atStart, atEnd, page } = useReelPagination(products.length)

  if (variant === "bare") {
    return (
      <div>
        <SectionHeader title={title} accent={accent} eyebrow={eyebrow} action={<SeeAllButton href={seeAllHref} />} className="px-gut mb-850 @3xl:mb-750" />
        <div className="relative">
          <WindowedReel windowSize={4} ref={ref} gap="250" snap="proximity" inset className="pb-100 @2xl:gap-500">
            {products.map((product, index) => (
              <div key={product.id} className="@2xl:w-rail-card w-34">
                <ProductCard product={product} rank={ranked ? index + 1 : undefined} />
              </div>
            ))}
          </WindowedReel>
          {overflowing && <RailArrows atStart={atStart} atEnd={atEnd} onPage={page} top="top-30.5 @3xl:top-33" />}
        </div>
      </div>
    )
  }

  return (
    <div className="bg-brand rounded-20x mx-gut overflow-hidden py-700">
      <SectionHeader title={title} accent={accent} eyebrow={eyebrow} tone="inverse" action={<SeeAllButton href={seeAllHref} tone="inverse" />} className="px-gut mb-500" />
      <div className="relative">
        <WindowedReel windowSize={4} ref={ref} gap="300" snap="proximity" inset className="pb-100 @3xl:gap-400">
          {products.map((product, index) => (
            <div key={product.id} className="w-44 @3xl:w-48">
              <ProductCard product={product} tone="inverse" rank={ranked ? index + 1 : undefined} />
            </div>
          ))}
        </WindowedReel>
        {overflowing && <RailArrows atStart={atStart} atEnd={atEnd} onPage={page} top="top-39.5 @3xl:top-32" tone="inverse" />}
      </div>
    </div>
  )
}
